import { ContactSection } from "../components/ContactSection";

export function ContactPage() {
  return <ContactSection />;
}
